'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = ['M0 128c0 6.4 3.8 12.2 9.7 14.7l50.1 21.5 21.5 50.1c2.5 5.9 8.3 9.7 14.7 9.7s12.2-3.8 14.7-9.7l21.5-50.1 50.1-21.5c5.9-2.5 9.7-8.3 9.7-14.7s-3.8-12.2-9.7-14.7l-50.1-21.5-21.5-50.1C108.2 35.8 102.4 32 96 32s-12.2 3.8-14.7 9.7L59.8 91.8 9.7 113.3C3.8 115.8 0 121.6 0 128zM192 32c0 3.3 2 6.2 5 7.4L233.8 54.2 248.6 91c1.2 3 4.2 5 7.4 5s6.2-2 7.4-5L278.2 54.2 315 39.4c3-1.2 5-4.2 5-7.4s-2-6.2-5-7.4L278.2 9.8 263.4-27c-1.2-3-4.2-5-7.4-5s-6.2 2-7.4 5L233.8 9.8 197 24.6c-3 1.2-5 4.2-5 7.4zm133.4 85.4c33.7 33.7 67.5 67.5 101.3 101.3 35.1-35.1 70.1-70.1 105.2-105.2 7.8-7.8 12.2-18.4 12.2-29.5s-4.4-21.6-12.2-29.5L489.5 12.2C481.6 4.4 471 0 460 0s-21.6 4.4-29.5 12.2c-35.1 35.1-70.1 70.1-105.2 105.2zM368 400c0 6.4 3.8 12.2 9.7 14.7l50.1 21.5 21.5 50.1c2.5 5.9 8.3 9.7 14.7 9.7s12.2-3.8 14.7-9.7l21.5-50.1 50.1-21.5c5.9-2.5 9.7-8.3 9.7-14.7s-3.8-12.2-9.7-14.7l-50.1-21.5-21.5-50.1c-2.5-5.9-8.3-9.7-14.7-9.7s-12.2 3.8-14.7 9.7l-21.5 50.1-50.1 21.5c-5.9 2.5-9.7 8.3-9.7 14.7z', 'M426.6 218.6L325.4 117.4 44.2 398.5C36.4 406.4 32 417 32 428s4.4 21.6 12.2 29.5l42.3 42.3C94.4 507.6 105 512 116 512s21.6-4.4 29.5-12.2L426.6 218.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;